import { Row } from "react-bootstrap";

import "./index.scss";

const CertificateTable = ({ certificateList, onViewCertificate }) => {
  if (!certificateList || certificateList.length === 0) return null;

  return (
    <Row className="certificate-table__row">
      <table className="certificate-table">
        <thead>
          <tr>
            <th>Sr</th>
            <th>Certificate No</th>
            <th>Customer Name</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {certificateList.map((item, index) => (
            <tr key={item?.id}>
              <td>{index + 1}</td>
              <td>{item?.certificatesNumber}</td>
              <td>{item?.customerName}</td>
              <td>
                <button
                  title="View Details"
                  className="certificate-table__view-btn"
                  onClick={() => onViewCertificate(item?.certificate_Url)}
                >
                  <i className="fas fa-eye"></i>
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Row>
  );
};

export default CertificateTable;
